import axiosInstance from "../../config/axiosInstance";

const createOperationRequest = async operation => {
  return await axiosInstance.dillApi().post("/operations", operation);
};

export default createOperationRequest;
